import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  // Project data array with multiple images per project
  const projectsData = [
    {
      id: 1,
      title: "Chair Recaning",
      images: [
        "/images/chair .jpeg",
        "/images/chair 1.jpeg",
      ],
      description: "Vocational training program providing chair recaning skills to empower individuals with disabilities",
      detailedContent: "A large number of recaning orders are received from Transport Corporations like P.R.C. Ltd for their driver seats and back rests. Our blind clients regularly execute these orders at corporate offices. The Social Welfare Department of the Government of Tamil Nadu issued Government Order M.S.2318 (SWD) dated 14.11.95 to government offices and undertakings, directing that recaning orders may be entrusted to Helen Keller Service Society for the Disabled without calling for tenders. The recaning orders bring regular earnings to our blind clients, providing them with sustainable employment and economic independence. Government support through direct order placement has created consistent income opportunities for visually impaired persons through skilled craftsmanship."
    },
    {
      id: 2,
      title: "VTC - Envelope Making Unit",
      images: [
        "/images/envolope.jpeg",
        "/images/envolope1.jpeg",
      ],
      description: "Vocational Training Center focused on envelope making, providing employment opportunities",
      detailedContent: "This Envelope Making Unit is well equipped with all the needed machineries and equipment. The unit takes the responsibility of training around 60 physically handicapped persons every year. Training on Envelope Making is given for twelve continuous months to every trainee, during which period they are given a stipend and transport allowance of Rs.400/- per month. All the managerial aspects are also taught to them to ensure comprehensive skill development. After the completion of training, trainees are given certificates and placement is arranged for suitable candidates, enabling them to secure employment and achieve economic independence through their newly acquired skills."
    },
    {
      id: 3,
      title: "VTC - Note Book Making Project",
      images: [
        "/images/notebook.jpeg",
        "/images/notebook1.jpeg"
      ],
      description: "Vocational Training Center for notebook manufacturing, creating sustainable livelihoods",
      detailedContent: "Similar to the Envelope Making Unit, we have expanded our Vocational Training Centre to accommodate a Note Book Making Unit. It is well equipped with all needed machineries and provides training to around 60 Physically Handicapped Persons on Note Book Making and File making every year. Every trainee is given one year continuous training on Note Book Making with a stipend and transport allowance of Rs.400/- per month for the whole one year. After training, placement is arranged for suitable candidates. This unit provides comprehensive skill development in notebook and file manufacturing, enabling physically handicapped persons to gain employment and achieve financial independence through sustainable livelihoods."
    },
    {
      id: 4,
      title: "VTC - Printing Unit",
      images: [
        "/images/printing.jpeg"
      ],
      description: "Professional printing services unit providing vocational training and employment",
      detailedContent: "Similar to our Envelope Making and Note Book Making Unit, we train our Physically Handicapped on printing also. They are given training on composing, dummy preparation and various aspects of printing operations. After training, they are given Certificates and Placement. During the period of training they are given a stipend and transport allowance of Rs.400/- per month. Additionally, the organization provides Vocational Training to Visually Handicapped in JAWS Computer Application. Training in the use of Computer JAWS to the Visually Handicapped students is imparted to equip them suitable for their future studies as well as employment. Annually 30-40 Visually Handicapped Students are trained in Computer JAWS operation, preparing them for higher education and employment opportunities in the digital age."
    },
    {
      id: 5,
      title: "Self Employment - Telephone Booth",
      images: [
        "/images/tele.jpeg",
        "/images/tele1.jpeg",
      ],
      description: "Self-employment initiative providing telephone booth services for economic independence",
      detailedContent: "28 Public Telephone Booths have been installed by the Society for the blind persons through which 28 blind persons are economically settled and having regular earnings. This self-employment initiative enables visually impaired persons to achieve economic independence through managing and operating their own telephone booth businesses. Each beneficiary manages their own booth, ensuring steady income and self-reliance. This program creates sustainable income sources and provides financial stability to blind persons, allowing them to live with dignity and independence in their communities."
    },
    {
      id: 6,
      title: "Talking Book Library",
      images: [
        "/images/book lib.jpeg",
        "/images/booklib1.jpeg",
        "/images/booklib2.jpeg",
        "/images/booklib3.jpeg"
      ],
      description: "Audio library service providing accessible literature for visually impaired individuals",
      detailedContent: "Our institution has established a new project in this part of the region, which will cater to the specific academic and information needs of the visually impaired persons. 'Talking Book Library for the Visually Impaired' is a very unique project in the field of rehabilitative services to the visually impaired persons. This important project has come into existence with the support from public donations and contribution from generous philanthropists. The Talking Book Library is providing the visually impaired persons the facility to avail study materials in an Audio Cassette form, for improving their academic and social skills and knowledge. Study Course Materials, Novels, Short Stories, News updates etc. can be provided through an audio cassette, whereby the visually impaired persons can have individualized hearing of the matter by playing the cassette on a tape recorder at home or by way of a headphone even while travelling. The recorded cassettes are stocked in a Library and distributed to the needy visually impaired person as and when a request comes to the center. During this year, around 1800 Visually Impaired students of schools and colleges were benefitted by this project. The project enables the visually impaired persons to live on par with other members of the society by providing news and other general knowledge information."
    },
    {
      id: 7,
      title: "Community Based Rehabilitation Service (CBRS)",
      images: [
        "/images/community.jpeg",
        "/images/communtiy1.jpeg",
        "/images/community2.jpeg",
        "/images/community3.jpeg",
        "/images/community4.jpeg",
        "/images/community5.jpeg"
      ],
      description: "Comprehensive community-based rehabilitation services for persons with disabilities",
      detailedContent: "Since Community Based Rehabilitation is the only option to carry out programs in a cost effective manner in developing countries like India, the society has implemented CBR for the incurably blind people. Training on Orientation and Mobility, Daily Living Skills, Manual Dexterity Skills and Vocational Training is provided to them by the locally recruited Multipurpose Workers. Besides that, permanent Economic Settlement is also provided for them with the help of Banks, Voluntary Agencies, Local Clubs and Philanthropists by way of arranging local trades. Around 200 Blind Persons are benefited out of this program every year. So far, the society has covered Thirupparankundram Union in Madurai District, Sivagangai, Kalayarkoil, Kallal, Thiruppuvanam Unions, Manamadurai sub taluk and Ilayankudi Taluk in Sivagangai District and Thiruppulani, Muthukulathur, Kadaladi, R.S.Mangalam, Ramnad and Pogalur Unions, Kamudhi, Paramakudi and Thiruvadanai Taluks in Ramanathapuram District and Veera Cholam, Narikudi, Aruppukottai, Virudhunagar, Sivakasi, Sattur in Virudhunagar District and Aranthangi, Ammapattinam, Pudukottai in Pudukottai District and totally covered the population strength of around 25 Lakhs."
    },
    {
      id: 8,
      title: "VIZHIYAGAM Eye Hospital",
      images: [
        "/images/eye1.jpeg",
        "/images/eye2.jpeg",
        "/images/eye3.jpeg",
        "/images/eye4.jpeg",
        "/images/eye5.jpeg",
        "/images/eye6.jpeg",
        "/images/eye7.jpeg"
      ],
      description: "Dedicated eye care hospital providing comprehensive ophthalmology services",
      detailedContent: "VIZHIYAGAM Eye Hospital, Salaigramam is well established with latest equipments. More than 5,000 Cataract Surgeries and 5,000 Minor Sight Restoration Surgeries are conducted every year. Around 80,000 people are treated for other eye care diseases every year. To render Eye Care Services at doorsteps, Screening/Diagnostic Eye Camps are conducted thrice a week. To make the Project a permanent one, a 50 bedded Eye Hospital has been constructed at Salaigramam, Sivagangai District with the help and support from the Federal Ministry of Economic Co-operation (BMZ), Germany, The German Lions and the Christoffel Blindenmission, Germany. This Comprehensive Project consists of four-dimensional services – Prevention, Cure, Rehabilitation and Promotion for the select around two million target rural population residing within 100 kms in and around Salaigramam, Sivagangai District, which is the remotest and the most neglected part in the State of Tamil Nadu."
    },
    {
      id: 9,
      title: "Eye Camp",
      images: [
        "/images/camp.jpeg",
        "/images/camp1.jpeg",
        "/images/camp2.jpeg",
      ],
      description: "Regular eye screening camps providing free eye check-ups and treatment to the community",
      detailedContent: "As part of the Prevention of Blindness Program, Community Teaching Programs are regularly conducted in the villages about immunization, personal hygiene, baby care, sanitation etc. Vitamin 'A' capsules are given to the children under the age of five years and regular Eye Screening Program are conducted in the villages and Schools. To render Eye Care Services at doorsteps, Screening/Diagnostic Eye Camps are conducted thrice a week. These community-based programs ensure that preventive eye care reaches even the remotest villages, helping to prevent avoidable blindness and promote eye health awareness among rural populations. The regular screening camps enable early detection and treatment of eye problems, while Vitamin A supplementation helps prevent childhood blindness in the region."
    }
  ];

  const openProjectDetail = (project) => {
    setSelectedProject(project);
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  const closeProjectDetail = () => {
    setSelectedProject(null);
    document.body.style.overflow = 'auto'; // Restore scrolling
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Our Projects</h1>
          <p className="text-xl text-gray-600">Empowering lives through vocational training and comprehensive care services</p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projectsData.map((project) => (
            <ProjectCard 
              key={project.id} 
              project={project}
              onClick={() => openProjectDetail(project)}
            />
          ))}
        </div>
      </div>

      {/* Project Detail Modal */}
      {selectedProject && (
        <ProjectDetailModal 
          project={selectedProject} 
          onClose={closeProjectDetail}
        />
      )}
    </div>
  );
};

// Separate component for each project card with image carousel
const ProjectCard = ({ project, onClick }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => 
      prev === project.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => 
      prev === 0 ? project.images.length - 1 : prev - 1
    );
  };

  const goToImage = (index, e) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
    >
      {/* Image Carousel */}
      <div className="relative h-64 overflow-hidden bg-gray-200 group">
        <img
          src={project.images[currentImageIndex]}
          alt={`${project.title} - Image ${currentImageIndex + 1}`}
          className="w-full h-full object-cover transition-transform duration-300"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23ddd" width="400" height="300"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="18" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3E' + encodeURIComponent(project.title) + '%3C/text%3E%3C/svg%3E';
          }}
        />

        {/* Navigation Arrows - Only show if more than 1 image */}
        {project.images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              aria-label="Previous image"
            >
              <FaChevronLeft size={20} />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              aria-label="Next image"
            >
              <FaChevronRight size={20} />
            </button>
          </>
        )}

        {/* Image Indicators/Dots */}
        {project.images.length > 1 && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex space-x-2">
            {project.images.map((_, index) => (
              <button
                key={index}
                onClick={(e) => goToImage(index, e)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentImageIndex
                    ? 'bg-white w-6'
                    : 'bg-white bg-opacity-50 hover:bg-opacity-75'
                }`}
                aria-label={`Go to image ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Image Counter */}
        {project.images.length > 1 && (
          <div className="absolute top-3 right-3 bg-black bg-opacity-60 text-white px-3 py-1 rounded-full text-sm">
            {currentImageIndex + 1} / {project.images.length}
          </div>
        )}
      </div>

      {/* Project Info */}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-3">
          {project.title}
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          {project.description}
        </p>
        <button className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-200">
          Learn More →
        </button>
      </div>
    </div>
  );
};

// Project Detail Modal Component
const ProjectDetailModal = ({ project, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === project.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? project.images.length - 1 : prev - 1
    );
  };

  // Close on escape key
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 z-50 overflow-y-auto"
      onClick={onClose}
    >
      <div className="min-h-screen px-4 py-8 flex items-center justify-center">
        <div 
          className="bg-white rounded-2xl max-w-5xl w-full shadow-2xl relative animate-fadeIn"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 bg-white hover:bg-gray-100 text-gray-800 rounded-full p-3 shadow-lg transition-all duration-200 hover:scale-110"
            aria-label="Close"
          >
            <FaTimes size={24} />
          </button>

          {/* Image Carousel */}
          <div className="relative h-96 overflow-hidden rounded-t-2xl bg-gray-200">
            <img
              src={project.images[currentImageIndex]}
              alt={`${project.title} - Image ${currentImageIndex + 1}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="400"%3E%3Crect fill="%23ddd" width="800" height="400"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="24" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3E' + encodeURIComponent(project.title) + '%3C/text%3E%3C/svg%3E';
              }}
            />

            {/* Navigation Arrows */}
            {project.images.length > 1 && (
              <>
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200"
                  aria-label="Previous image"
                >
                  <FaChevronLeft size={24} />
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200"
                  aria-label="Next image"
                >
                  <FaChevronRight size={24} />
                </button>

                {/* Image Counter */}
                <div className="absolute bottom-4 right-4 bg-black bg-opacity-70 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  {currentImageIndex + 1} / {project.images.length}
                </div>
              </>
            )}
          </div>

          {/* Content */}
          <div className="p-8 max-h-[60vh] overflow-y-auto">
            {/* Title */}
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {project.title}
            </h2>

            {/* Content Paragraph */}
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed text-lg whitespace-pre-line">
                {project.detailedContent}
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Projects;